export default "__VITE_ASSET__B4Dc78Tb__"